export { default as IconPromotion } from './IconPromotion';
export { type IconPromotionProps, default as useIconPromotion } from './useIconPromotion';
